import { SwiftCountryFeeType } from './types';

export function filterSwiftCountries(
  countries: SwiftCountryFeeType[],
  query: string
): SwiftCountryFeeType[] {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return countries;
  }

  return countries.filter((item) => item.country.toLowerCase().includes(normalizedQuery));
}

export function formatSwiftFee(feeUsd: number): string {
  return `${feeUsd.toFixed(2)} USD`;
}
